// console.log("mode", process.env.REACT_APP_ENV);

const serverUrl = {
  dev: "http://localhost:3004/v1",
  // test: "http://localhost:3002/v1",
  test: "http://200.105.69.248:3002/v1",
  prod: "https://app.tecnoclima.com.ar/api/v1",
};

const appConfig = {
  url: serverUrl[process.env.REACT_APP_ENV || "prod"],
  plantConfig: {
    code: "SSN",
  },
};

//line to check if gitignore worked. 05/09/22

export { appConfig };
